import React from 'react';
import LayerOverlay from './LayerOverlay';
import './DialogoDecision.css';

/* P2b tanda 8c (J11+J10) — DIÁLOGO DE DECISIÓN sobre la BASE COMÚN. Todo diálogo
   que pide CONFIRMAR una acción (renombrar un valor compartido, eliminar,
   restaurar, publicar incompleta) se monta acá, que vive sobre LayerOverlay: el
   mecanismo raíz del scroll lock ("si oscureces el fondo, lo congelas",
   23-jul-2026) y del fondo opaco. Reusa el markup/estilo `pp-confirm` ya
   aprobado, y conserva role="dialog" + aria-label para no cambiar el ruteo.
   Split por canal: los AVISOS informativos (p. ej. valor duplicado) NO pasan por
   acá — van a TOAST; sólo las DECISIONES. El backdrop cierra (onClose). */
export default function DialogoDecision({
  abierto = true,
  onClose,
  ariaLabel,
  className = '',       // p. ej. 'pp-publicar' para el ancho/estilo de esa variante
  children,
}) {
  return (
    <LayerOverlay open={abierto} className="dd-overlay" onBackdrop={onClose}>
      <div className={`pp-confirm${className ? ` ${className}` : ''}`} role="dialog" aria-label={ariaLabel}>
        {children}
      </div>
    </LayerOverlay>
  );
}
